import { executionEventMarkers } from '../executionEventMarkers'

export function clearExecutionEventMarkers() {
  executionEventMarkers.pod = null
  executionEventMarkers.events = []
  executionEventMarkers.visible = false
}
